"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var StatusWarning = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M20.6762281,16.4439502 C21.3394859,17.5746099 20.9511638,19.0233988 19.8088864,19.6799109 C19.4440973,19.8895697 19.0297764,20 18.6079519,20 L5.3916543,20 C4.0707801,20 3,18.9401105 3,17.6326705 C3,17.2151362 3.11156502,16.8050293 3.3233781,16.4439502 L9.93152689,5.17899911 C10.5947847,4.04833946 12.0584603,3.66396688 13.2007377,4.32047894 C13.560335,4.52715379 13.8592808,4.82305909 14.0680793,5.17899911 L20.6762281,16.4439502 Z M13.2055336,5.6849783 C13.08482,5.4791971 12.9115004,5.30764023 12.7024363,5.1874828 C12.0350195,4.80389199 11.1790699,5.02867102 10.7940726,5.68497826 L4.18592385,16.9499293 C4.06405436,17.157681 4,17.3931413 4,17.6326705 C4,18.3855244 4.62078942,19 5.3916543,19 L18.6079519,19 C18.855022,19 19.0975127,18.9353682 19.3105849,18.8129071 C19.9720132,18.432758 20.1951571,17.6002317 19.8136824,16.9499293 L13.2055336,5.6849783 Z M12,8 C12.5522847,8 13,8.44771525 13,9 L13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,9 C11,8.44771525 11.4477153,8 12,8 Z M12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 Z" })));
};
StatusWarning.displayName = 'StatusWarning';
exports.default = StatusWarning;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=StatusWarning.js.map